import BulkCallCampaign from "./BulkCampaign/Call";
import BulkEmailCampaign from "./BulkCampaign/Email";
import BulkSmsCampaign from "./BulkCampaign/Sms";
import BulkWhatsAppCampaign from "./BulkCampaign/WhatsApp";

const BulkCampaignRegistry = {
  sms: (props) => <BulkSmsCampaign {...props} />,
  whatsapp: (props) => <BulkWhatsAppCampaign {...props} />,
  call: (props) => <BulkCallCampaign {...props} />,
  email: (props) => <BulkEmailCampaign {...props} />,
};

export default function BulkCampaign(props) {
  const {
    bulkCampaign,
    onBulkCampaignClick,
    onBulkCampaignDelete,
    onBulkCampaignDownload,
    onBulkCampaignResume,
    onBulkCampaignPause,
    onBulkCampaignCancel,
    onBulkCampaignReport,
    isViewOnly
  } = props;

  const { campaignType } = bulkCampaign;

  return BulkCampaignRegistry[campaignType]({
    ...bulkCampaign,
    onBulkCampaignClick,
    onBulkCampaignDelete,
    onBulkCampaignDownload,
    onBulkCampaignResume,
    onBulkCampaignPause,
    onBulkCampaignCancel,
    onBulkCampaignReport,
    isViewOnly
  });
}
